import React from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, stopImpersonating, impersonatedUser } = useAuth();

  if (!isImpersonating()) {
    return null;
  }

  const handleStopImpersonating = async () => {
    try {
      await stopImpersonating();
    } catch (error) {
      console.error("Failed to stop impersonating", error);
      // Optionally show a toast message to the admin
    }
  };

  return (
    <div className="bg-yellow-400 text-black py-2 px-4 w-full flex items-center justify-between shadow-lg z-50 fixed top-0 left-0 right-0">
      <div className="flex items-center gap-3">
        <AlertTriangle className="h-5 w-5" />
        <span className="font-semibold">
          You are currently impersonating {impersonatedUser?.name || 'a user'}.
        </span>
      </div>
      <Button
        onClick={handleStopImpersonating}
        variant="destructive"
        size="sm"
      >
        Stop Impersonating
      </Button>
    </div>
  );
};

export default ImpersonationBanner; 